/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lang_SwitchInputs */

const et_lang_switch = /** @type {(inputs: Lang_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EN`)
};

const en_lang_switch = /** @type {(inputs: Lang_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ET`)
};

/**
* | output |
* | --- |
* | "ET" |
*
* @param {Lang_SwitchInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const lang_switch = /** @type {((inputs?: Lang_SwitchInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lang_SwitchInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_lang_switch(inputs)
	return en_lang_switch(inputs)
});